import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

import ImportSingleStyleModal from "pages/de/portfolio/components/ImportSingleStyleModal";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";

const AddProductCard = ({
  content = null,
  handleOk,
  sx = {},
  slot,
  handleRefresh = () => {},
  type = "card",
  ...rest
}) => {
  const [importStyleVisible, setImportStyleVisible] = useState(false);

  const handleShowAddStyleModal = () => {
    setImportStyleVisible(true);
  };

  if (type == "button") {
    return (
      <div>
        <SuiButton {...rest} onClick={handleShowAddStyleModal} variant="gradient" color="dark">
          {" "}
          {content ? content : "Import Style"}{" "}
        </SuiButton>{" "}
        {importStyleVisible ? (
          <ImportSingleStyleModal
            handleClose={() => setImportStyleVisible(false)}
            visible={importStyleVisible}
            isEdit={false}
            collection={null}
            handleRefresh={() => {
              handleRefresh();
            }}
            handleOk={handleOk}
            slot={slot}
            type="style"
          />
        ) : null}
      </div>
    );
  }

  return (
    <SuiBox
      sx={{
        border: "1px dashed",
        borderWidth: ({ borders }) => borders.borderWidth[2],
        borderColor: ({ borders }) => borders.borderColor,
        cursor: "pointer",
        height: 120,
        width: "100%",
        borderRadius: 4,
        ...sx,
      }}
      {...rest}
    >
      {content ? (
        content
      ) : (
        <SuiBox
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100%", width: "100%", cursor: "pointer" }}
          onClick={handleShowAddStyleModal}
        >
          <AddIcon fontSize="small" />
          <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
            Add Style
          </SuiTypography>{" "}
        </SuiBox>
      )}
      {importStyleVisible ? (
        <ImportSingleStyleModal
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          isEdit={false}
          collection={null}
          handleRefresh={() => {
            handleRefresh();
          }}
          handleOk={handleOk}
          slot={slot}
          type="style"
        />
      ) : null}
    </SuiBox>
  );
};

export default AddProductCard;
